<template>
  <div class="basic register-entrance">

   <div class="basic-header">
      <p>- 展会选择/Exhibition selection -</p>
    </div>

    <div class="choice">
      <Row :gutter="40">
        <Col span="24">
          <div class="select-box group1">
            <div class="select-content">
            <!-- @on-change="changeExId" -->
              <RadioGroup v-model="exhibitionSelectId"  >
                <template>
                  <Row>
                     <Col
                        span="24"
                        class="myRadio"
                      >
                        <Radio label="EC1CAB92-CE18-40D9-8AC6-07BA1DB6F305"  style='margin-top: 20px;'><span class="fontWeight">第90届全国药品交易会(2025年5月21日-23日 广州)</span></Radio>
                       <!-- <Radio label="C7F0AA44-FCC5-411F-96AC-82EB2BC365B6"  ><span class="fontWeight">第89届全国药品交易会(2024年11月20日-22日 武汉)</span></Radio> -->
                       
                      </Col>
                  </Row>
                </template>
              </RadioGroup>
              
            </div>
          </div>
        </Col>
      </Row>
    </div>


    <div class="basic-header" v-if='area1.length>0'>
      <p>- 展区选择/Select Exhibition & Booth -</p>
    </div>
    <div class="choice" v-if='area1.length>0'>
      <Row :gutter="40">
        <Col span="24">
        <div class="select-box group1">
          <div class="select-content">
            <RadioGroup v-model="areaName" vertical @on-change="changeArea">
              <template>
                <Row>

                 <template v-for="(item, index) in area1" v-if="!isZh">
                     <Col
                        span="6"
                        style="margin-bottom: 26px"
                        :key="index"
                        v-if="item.name.includes('海外品牌展区')"
                        class="myRadio"
                      >
                        <Radio :label="item.name" style='width:250px'
                          ><span class="fontWeight">{{ item.name }}</span></Radio
                        >
                      </Col>
                    </template>

                  <template v-for="(item, index) in area1" v-if="isZh">
                   <Col span="12" style="margin-bottom: 16px" :key="index" v-if="item.showIndex < 4">
                       <Radio :label="item.name"><span class='fontWeight'>{{item.name}}</span></Radio>
                    </Col>
                     <p v-else style='margin-bottom: 35px;'> 
                      <Radio :label="item.name"> <span class='fontWeight'>{{item.name}}</span> 
                      <span v-if="item.name=='医药研发供应链'">（研发服务、CRO 、CMO 、CDMO、MAH合作、注册咨询） </span>
                      <span v-if="item.name=='个人护理用品'">（湿巾类、棉柔巾、洁面巾、口腔护理、洗涤清洁、消杀防护、香氛精油、母婴护理、个护美健电器、OEM/ODM及其他关联产品） </span>
                      <span v-if="item.name=='中药材/中药饮片'">（大宗饮片、传统饮片、精致包装饮片、小包装饮片、直接口服固体饮片、破壁饮片、药食同源中药材及花草茶、中药配方颗粒、新型中药饮片、中药材、中药饮片生产设备、中药饮片包装等）</span>
                      <span v-if="item.name=='中医药养生'">（艾灸及艾产品、中医养生馆、足浴足疗药浴产品、中式药油/药膏、药膳、养生酒等）</span>
                      <span v-if="item.name=='中医诊疗及中医药设备'">（中医诊疗设备、中医器械、中药设备等）</span>
                      <span v-if="item.name=='医美融合产品'">（填充注射产品、美容抗衰仪器及设备、皮肤美容产品及技术、术后修复产品、中医美容产品、口服美容产品、智慧医美及康养体系、口腔整形耗材等）</span>
                      <span v-if="item.name=='互联网+医药'">（B2B、B2C、O2O等电商平台、健康管理平台、智能药柜、医药/医疗智能服务、医药互联网信息技术服务等）</span>
                      <span v-if="item.name=='医药物流技术与设备'">（仓储搬运、运输配送、冷链服务、智能设备等）</span>
                      <span v-if="item.name=='智慧营销'">（医学服务、数字营销、专项技术、品牌提示、培训咨询、市场调研、品牌设计等）</span>
                      <span v-if="item.name=='NHNE中国国际健康营养博览会'">（特殊营养食品、保健食品（蓝帽子）、膳食补充剂）</span>
                      <span v-if="item.name=='医用耗材'">（喷剂、凝胶、洗液、膏药、理疗贴、退热贴、热敷贴、IVD试纸等）</span>
                      <span v-if="item.name=='卫生材料'">（口罩、手套、护理垫、创面损伤敷料、手术用品、粘贴材料、护创材料、医用纺织品等）</span>
                      <span v-if="item.name=='家用医疗器械'">（血压计、血糖仪、体温计、听诊器、胎心仪、体重秤、呼吸机、制氧机、雾化仪）</span>
                      <span v-if="item.name=='成人用品'">（安全避孕用品、功能性情趣用品等）</span>
                      <span v-if="item.name=='中医诊疗'">（中医诊疗设备、中医器械）</span>
                      <span v-if="item.name=='康复辅助器具'">（护具、支具、轮椅、压力袜等）</span>
                      </Radio>
                    </p>

                    <!-- <Col span="12" style="margin-bottom: 16px" :key="index" v-if="item.name.length < 18">
                    <Radio :label="item.name"></Radio>
                    </Col>
                    <Col span="24" style="margin-bottom: 16px" :key="index" v-else>
                    <Radio :label="item.name"></Radio>
                    </Col> -->
                  </template>
                </Row>
              </template>
            </RadioGroup>
          </div>
        </div>
        </Col>
      </Row>
    </div>
    <div class="gap"></div>
    <div class="basic-header" v-if="selectArea.length">
      <p>- 展位选择/Space Type -</p>
    </div>
    <div class="choice" v-if="selectArea.length">
      <div class="select-box" style="padding-left:0;padding-right:0;">
        <div class="select-content">
          <Row>
            <Col span="24">
            <div class="top">
              <div class="top-title">特装展位/Raw Space<span class="top-txt2">(18m²起订/minimum)</span></div>
              <RadioGroup v-model="shellInfo" @on-change="changeType">
                <div class="top-item" v-for="(item, index) in shellArr" :key="'shell-' + index">
                  <Radio :label="item.pjCode" style="width:240px">{{item.pjName}} {{item.price}}元/m²</Radio>
                  <InputNumber :max="9999" :min="0" v-model="item.count" @on-change="changeInput($event, index, item)" style="width:80px;" :disabled="!(shellInfo && shellInfo === item.pjCode)">
                  </InputNumber>
                  <span style="padding-left: 10px">ｍ² </span>
                </div>
              </RadioGroup>
            </div>
            </Col>
            <Col span="24">
            <div class="top">
              <div class="top-title">标准展位/Standard Booth<span class="top-txt2">（规格/per unit 9m²/个）</span></div>
              <RadioGroup v-model="RawInfo" @on-change="changeType2">
                <div class="top-item" v-for="(item, index) in RawArr" :key="'raw-' + index">
                  <Radio :label="item.pjCode" style="width:240px">{{item.pjName}} {{item.price}}元/个</Radio>
                  <InputNumber :max="9999" :min="0" v-model="item.count" @on-change="changeInput($event, index, item)" style="width:80px;" :disabled="!(RawInfo && RawInfo === item.pjCode)">
                  </InputNumber>
                  <span style="padding-left: 10px">个 </span>
                </div>
              </RadioGroup>
            </div>
            </Col>
          </Row>
          <div style="padding: 0 15px;">
            <Checkbox v-model="isNeedUpdate" style="padding-bottom:10px;color: #666;">如需要进行“标改特”，请勾选</Checkbox>
            <Checkbox v-model="isNeedAngular" style="color: #666;">如有意预订转角位，请勾选此项。标准展位转角位置（两面开展位）加收原价格的20%</Checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="handle-box">
      <Button @click="validHandle" class="handle-box-btn" type="primary">提交</Button>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  props: {},
  data () {
    return {
      isNeedUpdate: false,
      isNeedAngular: false,
      company1: '',
      productName: '',
      areaName: [],
      areaType: '',
      RawInfo: null,
      // 特装展位
      shellArr: [],
      // 标准展位
      RawArr: [],
      shellInfo: null,
      RawInfo: null,
      area1: [],
      selectArea: [],
      selectAreaGroupId: '',

       exhibitionSelectId:"",
    };
  },
  computed: {
    exAreasOption () {
      return {
        clientId:this.exhibitionSelectId=='EC1CAB92-CE18-40D9-8AC6-07BA1DB6F305'? 37:34,
        // clientId: this.company1.clientId,
        languageType: "中文", // 中文|英文
      };
    },
     isZh() {
        console.log(this.$store.state.isZh,'this.$store.state.isZh;');
      return this.$store.state.isZh;
    },
  },
  watch: {
    isZh(newValue, oldValue) {
        this.selectArea =[]
         this.areaName =[]
        this.shellInfo=null
      console.log("isZh:", newValue);
      //   if (newValue) {
      //     this.getApplyCompanyGetAreasHandleNew();
      //   } else {
      //     this.getApplyCompanyGetAreasHandleNewEn();
      //   }
    },

     exhibitionSelectId(newValue, oldValue) {
      console.log("exhibitionSelectId:", newValue);
      this.area1 = []
      this.selectArea = [];
      this.areaName = [];
      this.shellInfo = null;
      this.getExhibitionHandle()
    },

  },
   created () {
    // this.getExhibitionHandle();
  },

  methods: {
    ...mapActions({
      getApplyCompanyGetAreasNew: 'registerdModule/getApplyCompanyGetAreasNew',
      getExhibitionById: 'registerdModule/getExhibitionById',
    }),
    async getExhibitionHandle () {
       sessionStorage.setItem('exhibitionSelectId', this.exhibitionSelectId);
      
    //   let res = await this.getExhibitionById("EC1CAB92-CE18-40D9-8AC6-07BA1DB6F305");
      let res = await this.getExhibitionById(this.exhibitionSelectId);
      if (res) {
        this.company1 = res;
        console.log('getExhibitionHandle', this.company1);
      }
      this.getApplyCompanyGetAreasHandleNew(); // 获取展区
    },

      async getApplyCompanyGetAreasHandleNew () {
      let res = await this.getApplyCompanyGetAreasNew(this.exAreasOption);
      if (res && res.length) { 
        this.area1 = res;
        console.log('area1', this.area1);
        console.log('getApplyCompanyGetAreasHandleNew', res);
      }
    },

    async validHandle () {
         if (!this.exhibitionSelectId) {
        this.$Message.error("请选择展会");
        return Promise.resolve({ valid: false });
      }
      if (!this.areaName) {
        this.$Message.error("请选择展区");
        return Promise.resolve({ valid: false });
      }
      if (!(this.RawInfo || this.shellInfo)) {
        this.$Message.error("请选择展位/Please select booth");
        return Promise.resolve({ valid: false });
      }
      let areaType = ''; // 展位类型 光地|标展
      let showArea = 0; // 展位类型为光地时 输入的展位面积
      let hallCount = 0; // 展位类型为标展时 输入的标展个数
      let selectType = null;
      if (this.shellInfo) {
        this.shellArr.forEach(c => {
          if (c.pjCode === this.shellInfo) {
            areaType = c.boothType;
            showArea = c.count;
            selectType = c;
          }
        });
      }
      if (this.RawInfo) {
        this.RawArr.forEach(c => {
          if (c.pjCode === this.RawInfo) {
            areaType = c.boothType;
            hallCount = c.count;
            selectType = c;
          }
        });
      } 
      console.log('areaType', areaType);
      console.log('showArea', showArea);
      console.log('hallCount', hallCount);
      if (areaType) {
        if (areaType === '光地' && showArea < 18) {
          this.$Message.error("请输入光地展位的面积(18㎡起订)/Please enter the size of the booth");
          return Promise.resolve({ valid: false });
        }
        if (areaType === '标展' && !hallCount) {
          this.$Message.error("请输入标准展位的个数/Please enter the number of standard booth");
          return Promise.resolve({ valid: false });
        }
      } else {
        this.$Message.error("请选择您预定的展位/Please select the booth");
        return Promise.resolve({ valid: false });
      }
      if (areaType === '标展') {
        showArea = hallCount * 9;
      }
      let order = {
        exhibitionId: this.company1.id,
        showArea: showArea,
        pType: selectType.pType,
        areaType: areaType,
        areaName: this.areaName,
        hallCount: hallCount,
        ApplyBoothOrder: {
          boothType: selectType.boothType,
          unit: selectType.cunit,
          dePjNameGroupId: this.selectAreaGroupId,
          gpName: selectType.gpName,
          groupId: selectType.groupId,
          dePjNameGroupName: this.areaName,
          pjCode: selectType.pjCode,
          pjFormat: selectType.pjFormat,
          unitPrice: selectType.price,
          monetaryUnit: selectType.pType,
          name: selectType.pjName,
          area: showArea,
        }
      };
      let res = {
        isNeedUpdate: this.isNeedUpdate,
        isNeedAngular: this.isNeedAngular,
        ApplyCompanyOrderNewDto: order || {},
        exhibition: this.company1
      }
      return Promise.resolve({ valid: true, ...res });
    },
    changeType (e) {
      this.RawInfo = '';
      setTimeout(c => {
        let arr1 = [...this.shellArr];
        let arr2 = [...this.RawArr];
        arr1.map(e => {
          e.count = 0;
        });
        arr2.map(e => {
          e.count = 0;
        });
        this.shellArr = [...arr1];
        this.RawArr = [...arr2];
        console.log('shellArr', this.shellArr);
        console.log('RawArr', this.RawArr);
      }, 200);
    },
    changeType2 (e) {
      this.shellInfo = '';
      setTimeout(c => {
        let arr1 = [...this.shellArr];
        let arr2 = [...this.RawArr];
        arr1.map(e => {
          e.count = 0;
        });
        arr2.map(e => {
          e.count = 0;
        });
        this.shellArr = [...arr1];
        this.RawArr = [...arr2];
        console.log('shellArr', this.shellArr);
        console.log('RawArr', this.RawArr);
      }, 200);
    },
    changeArea (e) {
      console.log('changeArea', e);
      this.selectAreaGroupId = e.id;
      console.log('selectAreaGroupId', this.selectAreaGroupId);
      let arr = [];
      this.RawArr = [];
      this.shellArr = [];
      setTimeout(c => {
        this.area1.map(c => {
          if (c.name === e) {
            arr = c.pjNames || [];
          }
        });
        arr.map(c => {
          c.count = 0;
        });
        arr.forEach(v => {
          if (v.boothType === '标展') {
            this.RawArr.push(v);
          } else if (v.boothType === '光地') {
            this.shellArr.push(v);
          }
        });
        // arr.forEach(v => {
        //   if (v.boothType === '标展'&& (this.isZh ? v.groupId == 1 : v.groupId == 2)) {
        //     this.RawArr.push(v);
        //   } else if (v.boothType === '光地'&& (this.isZh ? v.groupId == 1 : v.groupId == 2)) {
        //     this.shellArr.push(v);
        //   }
        // });
        this.selectArea = arr;
        this.shellInfo = null;
        this.RawInfo = null;
        console.log('selectArea', this.selectArea);
        console.log('标准展位', this.RawArr);
        console.log('特装展位', this.shellArr);
      }, 100);
    },
    changeInput (e, index, item) {
      console.log('e', e);
      console.log('index', index);
      console.log('item', item);
      console.log('RawArr', this.RawArr);
      console.log('shellArr', this.shellArr);
    },
  
  },
 
}


</script>

<style lang="scss" scoped>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #d00300 !important;
    }
    .ivu-radio-inner:after {
      background-color: #d00300;
    }
    .ivu-switch-checked {
      border-color: #d00300;
      background-color: #d00300;
    }
  }
  &-header {
    width: 100%;
    height: 50px;
    background-color: #d00300;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 50px;
      font-size: 15px;
    }
    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }
  &-title {
    line-height: 48px;
    font-size: 18px;
    background-color: #f2f2f2;
    color: #333;
    margin-bottom: 30px;
    padding-left: 30px;
    span {
      font-size: 13px;
    }
  }
}
.select-box {
  padding: 25px 15px;
  ::v-deep {
    .ivu-radio-wrapper {
      font-size: 13px;
    }
  }
}
.choice {
  background-color: #fff;
}
.choicebox {
  min-height: 686px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  &.active {
    background-color: #fdf7f9;
    border: solid 1px #d00300;
    .select {
      opacity: 1;
    }
    .choicebox-content ::v-deep {
      .ivu-radio-group-item {
        &:nth-child(odd) {
          background-color: #f5eff1;
        }
      }
    }
    .choicebox-tool {
      background-color: #f5eff1;
    }
  }
  .select {
    position: absolute;
    opacity: 0;
    text-align: center;
    top: 0;
    right: 0;
    width: 84px;
    height: 32px;
    line-height: 32px;
    background-color: #d00300;
    border-radius: 0px 0px 0px 10px;
    border: solid 1px #d00300;
    font-size: 12px;
    color: #fff;
  }
  &-top {
    padding: 30px 30px 20px;
    .txt1 {
      font-size: 15px;
      color: #333;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .txt2 {
      font-size: 12px;
      color: #666;
      margin-bottom: 8px;
    }
  }
  &-content {
    padding: 15px;
    .title {
      text-align: center;
      color: #333;
      margin-bottom: 20px;
    }
    .item {
      display: flex;
      align-items: center;
      flex: 1;
      &-box {
        width: 50%;
      }
      &-box2 {
        width: 50%;
        p {
          font-size: 12px;
          color: #333;
          font-weight: normal;
        }
      }
    }
    ::v-deep {
      .ivu-radio-group-item {
        width: 100%;
        display: flex;
        align-items: center;
        min-height: 74px;
        padding: 15px 10px 15px 20px;
        &:nth-child(odd) {
          background-color: #f7f7f7;
        }
      }
    }
  }
  &-tool {
    height: 73px;
    background-color: #f7f7f7;
    padding-left: 24px;
    display: flex;
    align-items: center;
  }
}
.select-box {
  .select-title {
    line-height: 48px;
    background-color: #f2f2f2;
    padding-left: 31px;
    font-size: 18px;
  }
}
.under-btn {
  ::v-deep {
    .ivu-input {
      position: relative;
      top: -2px;
      border: none;
      border-bottom: 1px solid #bfbfbf;
      border-radius: 0;
      &:hover,
      &:active {
        outline: none;
        box-shadow: none;
      }
    }
  }
}
.select-content-title {
  font-size: 15px;
  color: #333;
  margin-bottom: 18px;
}
.top {
  padding: 0 15px;
  color: #333;
  &-txt {
    font-size: 12px;
    padding-left: 29px;
    padding-bottom: 10px;
  }
  &-txt2 {
    color: #999;
    font-size: 14px;
  }
  &-title {
    font-size: 18px;
    margin-bottom: 28px;
  }
  &-item {
    margin-bottom: 26px;
  }
}
.bottom {
  padding: 0 15px;
}
.box {
  text-align: center;
  .line {
    height: 42px;
    font-size: 12px;
    color: #333;
    &:first-child {
      font-size: 12px;
      color: #fff;
      background-color: #d00300 !important;
      .ivu-col {
        border-right: 1px solid #fff;
      }
    }
    &:nth-child(odd) {
      background-color: #fff;
    }
    &:nth-child(even) {
      background-color: #f2fafe;
    }
    .ivu-col {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #d9f3ff;
      &:last-child {
        border-color: transparent !important;
      }
    }
  }
}
.tip {
  margin-top: 30px;
  font-size: 10px;
  color: #666;
}
.dot {
  position: relative;
  padding-left: 10px;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    width: 4px;
    height: 4px;
    background-color: #999;
    border-radius: 50%;
    top: 10px;
    margin-top: -2px;
  }
}
.last {
  margin-bottom: 0 !important;
}
.top-title2 {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 15px;
  color: #333;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  &.s-noline {
    border-bottom: none;
  }
  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-color: #d00300;
    margin-right: 7px;
  }
  span {
    font-size: 15px;
    .upload-btn2 {
      width: 105px;
      height: 105px;
      border: dotted 1px #bfbfbf;
      text-align: center;
      margin: 10px 15px;
      border-radius: 4px;
      position: relative;
      margin-left: 10px;
      img {
        position: absolute;
        width: 100%;
        height: 100%;
        margin: 0;
        top: 0;
        left: 0;
        z-index: 2;
      }
    }
    color: #f00;
  }
  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}
.gap {
  height: 15px;
  background: #f7f7f7;
  width: 100%;
}
.top-title {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 15px;
  color: #333;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-color: #d00300;
    margin-right: 7px;
  }
  span {
    font-size: 15px;
    color: #f00;
  }
  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}
.selectbox {
  margin: 15px;
  background-color: #fff;
  border-radius: 3px;
  overflow: hidden;
  border: solid 1px #e5e5e5;
  .other {
    line-height: 40px;
    width: 100%;
    padding-left: 14px;
    input {
      background: transparent;
    }
  }
  ::v-deep {
    .ivu-tree {
      > ul {
        padding-top: 2px;
        padding-bottom: 2px;
        border-bottom: solid 1px #e5e5e5;
        position: relative;
        padding-left: 10px;
        &:last-child {
          boder-bottom: none;
        }
      }
      .ivu-tree-arrow {
        position: absolute;
        right: 10px;
        top: 20px;
        margin-top: -10px;
      }
      .ivu-tree-arrow i {
        color: #999;
      }
    }
  }
}
.gap {
  height: 15px;
  background: #f7f7f7;
  width: 100%;
}

.group1  .ivu-radio-group{
    width:100%
}
.group1  .ivu-radio-group-vertical .ivu-radio-wrapper{
    display: inline-block;
        height: 50px;
    line-height: 20px;
}
.group1 .ivu-radio-wrapper{
     white-space: break-spaces;
}

.fontWeight{

    font-weight: 700;
    }
</style>
